export * from './linear/loading.linear.component';

import {LinearLoadingComponent} from './linear/loading.linear.component';

export const LOADING_COMPONENTS = [
    LinearLoadingComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/loading/index.ts